<script lang="ts" setup>
import { i18n } from '@/i18n';
import { businessContentName } from '@/appLogic/business/businessTableHeaders';
import TableHead from '@/components/atom/TableHead.vue';
import { TableType } from '@/coreDomainsModule/table';
import { TableCommonViewModel } from '@/viewModels/tableContent';
import TableCell from '@/components/atom/TableCell.vue';
import { ref } from 'vue';
import RowCheckBox from '@/components/atom/RowCheckBox.vue';
import { IBusinessProgressRateInfo } from '../domains/entities/businessProgressRateInfo';

// props
const props = withDefaults(
  defineProps<{
    tableType: TableType;
    items: IBusinessProgressRateInfo[]; // 取引進捗状況管理用のinterface
    scrollEnable?: boolean;
    editableLeadTime?: boolean;
    editableStdInventory?: boolean;
    onlyViewMode?: boolean;
  }>(),
  {
    scrollEnable: false,
    editableLeadTime: false,
    editableStdInventory: false,
    onlyViewMode: false,
  }
);

// emits
const emits = defineEmits<{
  (e: 'onClickLeadTimeButton', event: MouseEvent): void;
  (e: 'onClickStdInventoryButton', event: MouseEvent): void;
}>();

//変数
const t = i18n.t;
const commonTableContentVm = new TableCommonViewModel();
const isAllChecked = ref(false);

/**
 * テーブルに存在するチェックボックスを全選択する
 * @param isChecked - チェックボックスの状態
 */
const selectAllLines = (isChecked: boolean) => {
  // 単一のチェックマークしか押せないように
  if (commonTableContentVm.checkOnlySingleCheckboxTables(props.tableType)) {
    return;
  }
  // // 全選択用のフラグを切り返る
  // state.isAllChecked = isChecked;
  // // 全選択のチェックボックスがtrueかどうか？
  // if (state.isAllChecked) {
  //   // virtualChild = false の取引のみを対象とする
  //   const parentDisplayObjects = computedDisplayObjects.value
  //     .filter((obj) => !obj.virtualChild)
  //     .filter((obj) => Object.hasOwn(obj, displayObjectKey)); // 表示要素がitemId, bomIdの場合、プロパティがundefinedの可能性があるため ただし、もっと上位でやるべきでは？
  //   state.checkedIds = parentDisplayObjects.map((x) => x[displayObjectKey]);
  // } else {
  //   // 選択解除
  //   clearCheckIds();
  // }
  // if (onCheckIds) onCheckIds(state.checkedIds, props.tableType);
};

/**
 * 更新率計算
 * @param updated -
 * @param total -
 */
const testMethod = (updated: number, total: number): number => {
  const progressRate = Math.floor((updated / total) * 100);
  if (!isFinite(progressRate)) {
    if (Number.isNaN(progressRate) || progressRate === undefined) return 0;
    return 100;
  }
  return progressRate;
};
</script>

<template>
  <div class="simple-business-table">
    <table class="table-container">
      <thead>
        <tr>
          <template v-for="(property, index) in commonTableContentVm.displayHeaders[tableType]" :key="index">
            <!-- チェックボックス -->
            <template v-if="property === 'choice'">
              <TableHead :text-align="'left'">
                <RowCheckBox
                  v-if="!props.onlyViewMode"
                  v-model="isAllChecked"
                  :is-checked="isAllChecked"
                  @change-status="selectAllLines($event)"
                />
              </TableHead>
            </template>
            <!-- 更新率 -->
            <template v-else>
              <TableHead :text-align="'left'">
                {{ businessContentName[property] }}
              </TableHead>
            </template>
          </template>
        </tr>
      </thead>
      <tbody class="body-container">
        <template v-for="(item, itemIndex) in props.items" :key="itemIndex">
          <tr class="item-container">
            <template v-for="(property, propertyIndex) in commonTableContentVm.displayHeaders[tableType]" :key="propertyIndex">
              <!-- チェックボックス -->
              <template v-if="property === 'choice'">
                <TableCell>
                  <RowCheckBox
                    v-if="!props.onlyViewMode"
                    v-model="isAllChecked"
                    :is-checked="isAllChecked"
                    @change-status="selectAllLines($event)"
                  />
                </TableCell>
              </template>
              <!-- 更新率 -->
              <template v-else-if="property === 'progressRate'">
                <TableCell :text-align="'left'" scope="col">
                  {{ `${testMethod(item.updatedBusinessCount, item.totalBusinessCount)}%` }}
                </TableCell>
              </template>
              <!-- その他 -->
              <template v-else>
                <TableCell>
                  {{ item[property] }}
                </TableCell>
              </template>
            </template>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<style lang="scss" scoped>
.table-container {
  width: 100%;
  height: 100%;
  background-color: $backgroundDefault;
}
.item-container td {
  padding: 4px 16px 4px 16px;
}
</style>
